<div class="llama-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close Llama 3.3 Info">
    <span aria-hidden="true"><i class="fas fa-bars"></i></span>
  </button>

  <div class="header">
    <img src="assets/logos/meta.svg" alt="Llama 3.3 70B Logo" class="logo" />
    <h2>Llama 3.3 70B</h2>
    <div class="sub">Meta AI’s Large, Open, & Adaptable Language Model</div>
  </div>

  <div class="body">
    <p>
      <strong>Llama 3.3 70B</strong> is Meta AI’s latest open-access large language model, offering an exceptional blend of power, speed, and flexibility for developers and researchers. It excels at a wide range of conversational and technical tasks, thanks to its 70-billion parameter architecture and open ecosystem.
    </p>

    <ul>
      <li>🦙 <strong>Open & Adaptable:</strong> Fully open weights, adaptable for research and custom use-cases.</li>
      <li>💡 <strong>Powerful Reasoning:</strong> Handles complex tasks, code, and logical problem-solving efficiently.</li>
      <li>🌐 <strong>Multilingual & Broad:</strong> Strong performance across many languages and domains.</li>
      <li>⚡ <strong>Cost-Effective:</strong> Delivers high quality with lower infrastructure costs than closed models.</li>
      <li>🔓 <strong>Community Driven:</strong> Vast ecosystem of extensions, fine-tuning, and community support.</li>
    </ul>

    <div class="optimal">
      <h3>When is Llama 3.3 70B optimal?</h3>
      <ul>
        <li>✔️ For developers seeking open, auditable models with large context windows</li>
        <li>✔️ When you need a powerful model for coding, chatbots, research, or fine-tuning</li>
        <li>✔️ Ideal for multilingual applications and projects with budget or privacy constraints</li>
        <li>✔️ When you want to fully control, extend, or self-host your AI models</li>
      </ul>
    </div>
  </div>
</div>
